export default function getResource(label, vars = []) {
    const resources = {
        UPCOMING: 'Upcoming',
        PAST: 'Past',
        CANCELLED: 'Cancelled',
        CANCELLED_BY_STORE: 'Canceled By Store',
        LATE_CANCELLATION: `Late Cancelation $${vars[0]} Fee`,
        NO_SHOW: `No Show $${vars[0]} Fee`,
        title: 'My Reservations',
        bookService: 'Book a Service',
        bookEvent: 'Book Events',
        cancelEvent: 'Are you sure you want to cancel your RSVP?',
        less24HoursCancel: 'Are you sure you want to cancel? Canceling within 24 hours of your appt will incur a $XX charge. See policies for more details',
        normalCancel: 'Are you sure you want to cancel?',
        modalContent: 'Are you sure you want to cancel your RSVP?',
        modalNoButton: 'No',
        modalYesButton: 'Yes',
        showMoreButton: 'Show More Reservations'
    };

    return resources[label];
}
